import React from 'react';
import dayjs from 'dayjs';
import { setCurrentDate, goToNextMonth, goToPreviousMonth, resetCurrentDate } from '../features/calendar/calendar-slice';
import { useAppSelector } from '../app/hooks';
import { useIsDirectionOutOfRange, NavigationDirection } from '../app/is-direction-out-of-range-hook';
import { useAppDispatch } from '../app/store';
import { getWeekdays, DATE_FORMAT, UI_MONTH_FORMAT, fillWeeksForGrid, getMonthsInRange, getDateModifiers } from '../helpers/date-helpers';
import { Month } from '../helpers/common-types';
import { MonthDropdown } from './month-dropdown';
import { SvgIcon } from './svg-icon';

export type MiniCalendarProps = {
    filteredEvents: Month[] | undefined;
    dayClickedCallback?: () => void;
}

export function MiniCalendar(props: MiniCalendarProps) {
    const { filteredEvents, dayClickedCallback } = props;
    const dispatch = useAppDispatch();
    const weekdays = getWeekdays();

    const currentDate = useAppSelector(state => state.calendar.currentDate);
    const today = useAppSelector(state => state.calendar.todaysDate);
    const eventsAreLoading = useAppSelector(state => state.calendar.eventsAreLoading);
    const { previousMonthButtonText, nextMonthButtonText, todayButtonText } = useAppSelector(state => state.settings);

    const currentMonthData = filteredEvents ? filteredEvents[0] : null;
    const [nextOutOfRange, prevOutOfRange] = useIsDirectionOutOfRange();

    const dayClicked = (e: React.MouseEvent, date: string) => {
        dispatch(setCurrentDate({ newDate: date, shouldChangeRange: false }));
        if (dayClickedCallback) {
            dayClickedCallback();
        }
    }

    const todayClicked = () => {
        dispatch(resetCurrentDate(true));
        if (dayClickedCallback) {
            dayClickedCallback();
        }
    }

    return (
        <div className="mini-cal-column">
            {
                !!currentMonthData &&
                <nav className="mini-cal-container">
                    <div className="mini-cal-month flex-between align-items-center">

                        <div className="mini-cal-month-dropdown">
                            <MonthDropdown hideLabel={true} />
                        </div>


                        <button className="btn-primary align-self-stretch" onClick={todayClicked}>
                            {todayButtonText}
                        </button>
                    </div>
                    <ul className="mini-cal-weekdays">
                        {
                            weekdays.map((day, index) => (
                                <li className="mini-cal-weekday">
                                    {day}
                                </li>
                            ))
                        }
                    </ul>
                    <ul className="mini-cal-days">
                        {
                            fillWeeksForGrid(currentMonthData.days).map((day, index) => (
                                <MiniCalendarItem date={day.date} hasEvents={day.events.length > 0} modifiers={getDateModifiers(day, today, currentDate, currentMonthData.month, 'mini-cal-day-')} clickEvent={dayClicked} />
                            ))
                        }
                    </ul>
                </nav>
            }
        </div>
    );
}

const MiniCalendarItem = (props: { date: string, hasEvents: boolean, modifiers: string, clickEvent: any }) => {
    const { date, hasEvents, modifiers, clickEvent } = props;
    return (
        <li className={`mini-cal-day ${modifiers}`}>
            {
                hasEvents ?
                    <button onClick={(e) => clickEvent(e, date)} className="mini-cal-day-btn">
                        {dayjs(date).format('D')}
                    </button>
                    :
                    <span>
                        {dayjs(date).format('D')}
                    </span>
            }
        </li>
    )
}